import { render, staticRenderFns } from "./TestCheckCategory.vue?vue&type=template&id=4b2e9f5e&scoped=true&"
import script from "./TestCheckCategory.vue?vue&type=script&lang=js&"
export * from "./TestCheckCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2e9f5e",
  null
  
)

export default component.exports